import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["bookSlider"]

  declare readonly bookSliderTarget: HTMLElement

  setBookColor({ detail: { color } }) {
    this.element.style.setProperty("--override-accent-color", color)
  }

  setPageLayout({ detail: { pageType, image } }) {
    if (pageType == "front-cover") {
      const pageHost = this.bookSliderTarget.querySelector(
        ":scope [data-slide-type='front-cover'] shadow-page",
      )
      ;(pageHost.shadowRoot.querySelector("#front-cover-image") as HTMLImageElement).src = image
    } else if (pageType == "last-page") {
      const pageHost = this.bookSliderTarget.querySelector(
        ":scope [data-slide-type='last-page'] shadow-page",
      )
      ;(pageHost.shadowRoot.querySelector("#last-page-image") as HTMLImageElement).src = image
    }
  }
}
